import homescreen from "../assets/img/homescreen_v3.png";
import { useEffect, useRef, useState } from "react";
import { CommentBox } from "../Components/CommentBox";
import { NavBar } from "../Components/NavBar";
import { useMainStore } from "../Zustand/main.store";
import Sidebar from "./Sidebar/Sidebar";
import PdfSkeleton from "../Components/PdfSkeleton";
import { useApiGetDocumentByMunicipality } from "../API/documentationCatalogs.api";

export const Home = () => {
  const selectedPdfId = useMainStore((s) => s.selectedPdfId);
  const [iframeUrl, setIframeUrl] = useState<string>("");

  // Keep track of the current object URL to revoke it when changing PDFs
  const currentObjectUrlRef = useRef<string | null>(null);

  const { call: fetchDocument, loading: fetchDocumentLoading } =
    useApiGetDocumentByMunicipality({
      onCompleted: (res) => {
        // Revoke previous URL if any
        if (currentObjectUrlRef.current) {
          URL.revokeObjectURL(currentObjectUrlRef.current);
          currentObjectUrlRef.current = null;
        }
        // Ensure the blob has the correct PDF MIME type so the browser renders it instead of downloading
        const pdfBlob = new Blob([res.data], { type: "application/pdf" });
        const objectUrl = URL.createObjectURL(pdfBlob);

        currentObjectUrlRef.current = objectUrl;
        setIframeUrl(objectUrl);
      },
      onError: () => {
        // On error, clear current URL and revoke any previous one
        if (currentObjectUrlRef.current) {
          URL.revokeObjectURL(currentObjectUrlRef.current);
          currentObjectUrlRef.current = null;
        }
        setIframeUrl("");
      },
    });

  // Fetch and display the currently selected PDF by id
  useEffect(() => {
    let isCancelled = false;

    const run = async () => {
      if (selectedPdfId != null && !fetchDocumentLoading) {
        try {
          await fetchDocument(selectedPdfId);
        } catch {
          if (!isCancelled) setIframeUrl("");
        }
      } else {
        // If no selection, clear iframe and revoke previous URL
        if (currentObjectUrlRef.current) {
          URL.revokeObjectURL(currentObjectUrlRef.current);
          currentObjectUrlRef.current = null;
        }
        setIframeUrl("");
      }
    };

    run();

    return () => {
      isCancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPdfId]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (currentObjectUrlRef.current) {
        URL.revokeObjectURL(currentObjectUrlRef.current);
        currentObjectUrlRef.current = null;
      }
    };
  }, []);

  return (
    <>
      <NavBar />
      {/* Container for Sidebar and Main Content */}
      <div className="flex">
        <Sidebar />
        <div className="flex-1 p-6">
          {iframeUrl !== "" || fetchDocumentLoading ? (
            <div className="h-[calc(100vh-100px)]">
              {fetchDocumentLoading ? (
                <PdfSkeleton />
              ) : (
                <iframe
                  src={iframeUrl}
                  width="100%"
                  height="100%"
                  title="PDF Viewer"
                  className="h-full"
                  style={{ border: "none" }}
                />
              )}
            </div>
          ) : (
            <div className="w-full flex justify-center">
              <img className="bg-slate-500" src={homescreen} alt="logo" />
            </div>
          )}

          {/* Comment Box */}
          {selectedPdfId !== null && <CommentBox />}
        </div>
      </div>
      {/* <Chatbot /> */}
    </>
  );
};
